import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import { StyledSelect, StyledSelectPropTypes } from 'site-modules/shared/components/styled-select/styled-select';

import './select.scss';

export function Select({ className = '', ...rest }) {
  return (
    <StyledSelect
      {...rest}
      className={classnames('inventory-select', className)}
      wrapperClassName="inventory-select-wrapper"
    />
  );
}

Select.propTypes = {
  ...StyledSelectPropTypes,
  className: PropTypes.string,
};

Select.displayName = 'Select';
